export const cityName = "Ріпкинська"
export const cityCouncil = "селищна рада"
export const altCityName = "Логотип Ріпкинської селищної ради"

export const territory_title = "Ріпкинська селищна рада"
export const territory_title_instrumental = "Ріпкинської селищної територіальної громади"

export const website_name = "Портал місцевих податків Ріпкинської громади"
export const website_url = "https://ripku.skydatagroup.com/"
export const website_url_p4v = "https://p4v.ripku.skydatagroup.com/"
export const telegram_name ="Місцеві податки Ріпкинської ТГ"
export const telegram_url ="https://t.me/Ripku_taxes_bot"
export const phone_number_GU_DPS = "(04626) 5-23-97"
export const alt_qr_code = "Qr-code Ріпки"
export const GU_DPS_region = "Чернігівській області"

export const COMMUNITY_NAME = ""